const QueryStringValue = {
  PendingTray: 'pending-tray',
  File: 'file',
};

export default QueryStringValue;
